import { FC, useEffect } from 'react';
import kiosksStore from './store/kiosksStore';
import KiosksHeader from './containers/KiosksHeader/KiosksHeader';
import KiosksList from './containers/KiosksList/KiosksList';
import { SCREENS } from '~/constants/screens';
import { localeStore } from '~/mobx/localesStore';
import Headers from '~/view/containers/Headers/Headers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';

const KiosksScreen: FC = (): JSX.Element => {
  useEffect(() => {
    kiosksStore.fetchKiosks();

    return () => kiosksStore.clearFilters();
  }, []);

  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title={localeStore.t('kiosks')} path={SCREENS.SETTINGS()} />
      </Headers>

      <div className="d-flex flex-column flex-1 mt-6">
        <KiosksHeader />
        <KiosksList />
      </div>
    </div>
  );
};

export default KiosksScreen;
